// Texto preto ou branco conforme a luminância da cor de fundo (#rgb ou #rrggbb)
export const contrastText = (hex = "") => {
  let value = hex.replace("#", "");
  if (value.length === 3) {
    value = value.split("").map((c) => c + c).join("");
  }
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  if ([r, g, b].some(Number.isNaN)) return "#FFFFFF";
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? "#1E1B2E" : "#FFFFFF";
};
